/**
 *  [2021] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: logout,ログアウト
 * note:
 *  - ログアウトしてIDトークンを削除し、ログイン画面に戻る
 *  - WebappのVueコンポーネントから呼び出されることを想定している
 * sample:
 *  -
 * :ZNOTE:
 */

import {clearAuthInfo, awsLogout} from '@zettant/awsUtils';

export const normalLogout = async (reason?: string) => {
  try {
    await awsLogout();
  } catch (e) {
    clearAuthInfo();  // エラーが発生したとしてもとりあえず消す
  }
  if (reason) alert(reason);
  location.href = '/auth';
};
